import { Component, OnInit, Input } from '@angular/core';
import { StorageService } from '../../../service/managers/storage.service';
import { RouterManagerService } from '../../../service/managers/router-manager.service';

@Component({
  selector: 'app-restriction',
  templateUrl: './restriction.component.html',
  styleUrls: ['./restriction.component.scss']
})
export class RestrictionComponent implements OnInit {

  private visible: boolean = false;

  constructor(private routerManager: RouterManagerService) {

  }

  ngOnInit() {
    this.routerManager.restrictThroughPermissions(this.permissions, this.operation);
    this.visible = this.routerManager.arePermissionsAuthorized();
  }

  /**
   *  Grants access to any permission listed.
   */
  @Input() public permissions: string[];

  /**
   * Grants access if satisfies all permissions listed.
   */
  @Input() public operation: string;

  protected isVisible() {
    return this.visible;
  }

}
